import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-site-design',
    template: `
        <div class="fi-container ExtraLightBackgroundColor">
            <ui-view></ui-view>
        </div>
    `,
    styleUrls: ['./fi-site-design.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-design' },
    standalone: false,
})
export class FiSiteDesignComponent {}
